<template>
  
<div>
  
<v-app>

    <v-snackbar
      :timeout="snackbar.timeout"
      :top="snackbar.y === 'top'"
      :bottom="snackbar.y === 'bottom'"
      :right="snackbar.x === 'right'"
      :color="snackbar.color"
      text="teal"
      :left="snackbar.x === 'left'"
      :multi-line="snackbar.mode === 'multi-line'"
      :vertical="snackbar.mode === 'vertical'"
      v-model="snackbar.display"
    >
      {{ snackbar.text }}
      <v-btn
        v-if="snackbar.showButton"
        :flat="snackbar.flat" 
        :color="snackbar.buttonColor"
        @click.native="snackbar.display = false"
      >
        {{ snackbar.buttonText }}
      </v-btn>
    </v-snackbar>

    <div v-if="isSessionMannagerPage()" id="session-mannager-page">
      <v-slide-y-transition mode="out-in">
        <router-view :key="$route.path"></router-view>
      </v-slide-y-transition>

    </div>

    <div v-if="!isSessionMannagerPage()" id="eeeeeeee">

      <v-navigation-drawer
        
        :mini-variant="miniVariant"
        :clipped="clipped"
        v-model="drawer"
        fixed
        app
      >
        <v-toolbar flat>
          <v-list>
            <v-list-tile>
              <v-list-tile-title class="title">
                Instalaciones BEC
              </v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-toolbar>
        <v-divider></v-divider>
        <v-list>
          <v-list-tile
            exact
            router
            :to="{
              name: 'dashboard'
            }"
          >
            <v-list-tile-title class="list-title" v-text="'Home'"></v-list-tile-title>
          </v-list-tile>
          <v-divider></v-divider>
          <v-list-tile
            exact
            router
            :to="{
              name: 'account',
              params: {
                username: 'me'
              }
            }"
          >
            <v-list-tile-title class="list-title" v-text="'Mi cuenta'"></v-list-tile-title>
          </v-list-tile>
          <v-divider></v-divider>
          <v-list-tile
            exact
            router
            :to="{
              name: 'stats'
            }"
          >
            <v-list-tile-title class="list-title" v-text="'Estadísticas'"></v-list-tile-title>
          </v-list-tile>
          <v-divider></v-divider>
       </v-list>
        <v-expansion-panel>
          <v-expansion-panel-content v-if="!(parent.hidden || false)" v-for="(parent, i) in parents" :key="i">
            <div slot="header">
              <v-icon v-html="parent.icon"></v-icon> 
            {{ parent.title }}
            </div>
            <v-list>
              <v-list-tile 
                v-if="!(child.hidden || false)"
                router
                :to="child.to"
                :key="i"
                v-for="(child, i) in parent.childs"
                exact
              >
                <v-list-tile-action>
                  <v-icon v-html="child.icon"></v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title v-text="child.title"></v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-list>
          <v-list-tile
            exact
            router
            @click="logout()"
          >
            <v-list-tile-title class="list-title" v-text="'Salir'"></v-list-tile-title>
          </v-list-tile>
       </v-list>
      </v-navigation-drawer>

      <v-toolbar v-if="false" fixed>
        <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      </v-toolbar>

      <v-toolbar  fixed app :clipped-left="clipped">
        <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
        <v-btn
          v-if="false"
          icon
          @click.native.stop="miniVariant = !miniVariant"
        >
          <v-icon v-html="miniVariant ? 'chevron_right' : 'chevron_left'"></v-icon>
        </v-btn>
        <v-tooltip bottom>
          <v-btn
            icon
            slot="activator"
            :to="{
              name: 'dashboard'
            }"
            @click.native.stop="clipped = !clipped"
          >
            <v-icon>home</v-icon>
          </v-btn>
          <span>Home</span>
        </v-tooltip>

        <v-tooltip bottom v-if="isSuperadmin() || isAdmin()">
          <v-btn
            icon
            slot="activator"
            :to="{
              name: 'equipments'
            }"
            @click.native.stop="clipped = !clipped"
          >
            <v-icon>settings_input_component</v-icon>
          </v-btn>
          <span>Ver equipos</span>
        </v-tooltip>

        <v-tooltip bottom v-if="isSuperadmin() || isAdmin()">
          <v-btn
            icon
            slot="activator"
            :to="{
              name: 'installers'
            }"
            @click.native.stop="clipped = !clipped"
          >
            <v-icon>build</v-icon>
          </v-btn>
          <span>Ver instaladores</span>
        </v-tooltip>

        <v-tooltip bottom>
          <v-btn
            icon
            slot="activator"
            :to="{
              name: 'bookings'
            }"
            @click.native.stop="clipped = !clipped"
          >
            <v-icon>alarm</v-icon>
          </v-btn>
          <span>Ver reservas</span>
        </v-tooltip>

        <v-tooltip bottom v-if="isSuperadmin() || isAdmin() || isCommerce()">
          <v-btn
            icon
            slot="activator"
            :to="{
              name: 'bookingnew',
              params: {
                booking_id: 'new'
              }
            }"
            @click.native.stop="clipped = !clipped"
          >
            <v-icon>alarm_add</v-icon>
          </v-btn>
          <span>Nueva reserva</span>
        </v-tooltip>

        <v-tooltip bottom v-if="isSuperadmin() || isAdmin()">
          <v-btn
            icon
            slot="activator"
            :to="{
              name: 'bookings',
              query: { action: 'mark_as_finished' }
            }"
            @click.native.stop="clipped = !clipped"
          >
            <v-icon>alarm_on</v-icon>
          </v-btn>
          <span>Marcar reservas como finalizadas</span>
        </v-tooltip>

        <v-btn
          v-if="false"
          icon
          @click.native.stop="fixed = !fixed"
        >
          <v-icon>remove</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
          <img
            class="white-logo"
            src="/static/images/login/logo-blanco.png"
            alt=""
          >
        
        
        <v-btn
          v-if="false"
          icon
          @click.native.stop="rightDrawer = !rightDrawer"
        >
          <v-icon>menu</v-icon>
        </v-btn>
      </v-toolbar>

      <v-content>
        <v-container fluid>
          <br><br><br>
          <v-slide-y-transition mode="out-in">
            <router-view :key="$route.path"></router-view>
          </v-slide-y-transition>
        </v-container>
      </v-content>

      <v-navigation-drawer
        temporary
        v-if="false"
        :right="right"
        v-model="rightDrawer"
        fixed
      >
        <v-list>
          <v-list-tile @click.native="right = !right">
            <v-list-tile-action>
              <v-icon light>compare_arrows</v-icon>
            </v-list-tile-action>
            <v-list-tile-title>Switch drawer (click me)</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-navigation-drawer>

      <v-footer :fixed="fixed" height="65px" class="footer-app-inside" app>
        <v-container fluid>
          <v-layout row align-center justify-center>
            <span>&copy; Instalaciones BEC - 2019</span>
          </v-layout>
          <v-layout row align-center justify-center>

              <router-link :to="{ name: 'legal-advice' }">
                Aviso legal
              </router-link>
<span class="router-separator"> | </span>

              <router-link :to="{ name: 'privacy-policy' }">
                Privacidad
              </router-link>

<span class="router-separator"> | </span>
              <router-link :to="{ name: 'cookies-policy' }">
                Cookies
              </router-link>

          </v-layout>
        </v-container>
      </v-footer>

    </div>

  </v-app>
</div>
</template>

<script>
import Meta from 'mixins/meta'
import Theme from 'mixins/theme'
import moment from 'moment'

export default {
  mixins: [Meta, Theme],

  data () {
    return {
      fullscreenDialog: this.$store.getters['dialog/getFullscreenConfig'],
      snackbar: this.$store.getters['snackbar/getDefaultConfig'],
      clipped: false,
      drawer: false,
      fixed: false,
      dialog: false,
      notifications: false,
      sound: true,
      widgets: false,
      parents: [
        {
          title: 'Reservas',
          icon: '',
          childs: [
            /*
            {
              title: 'Nueva reserva',
              icon: '',
              hidden: this.isInstaller(),
              to: {
                name: 'booking-new',
                params: {
                  booking_id: 'new',
                  booking_start: moment().format('YYYY-MM-DD_HH:mm'),
                  booking_end: moment().format('YYYY-MM-DD_HH:mm')
                }
              }
            },
            */
            {
              title: 'Nueva reserva',
              icon: '',
              hidden: this.isInstaller() || this.isManager() || this.isResponsible(),
              to: {
                name: 'booking-id',
                params: {
                  booking_id: 'new'
                }
              }
            },
            {
              title: 'Ver reservas',
              icon: '',
              to: {
                name: 'bookings'
              }
            }
          ]
        },
        {
          title: 'Equipos',
          hidden: this.isInstaller() || this.isCommerce() || this.isManager() || this.isResponsible(),
          icon: '',
          childs: [
            {
              title: 'Nuevo equipo',
              icon: '',
              to: {
                name: 'equipment-id',
                params: {
                  equipment_id: 'new'
                }
              }
            },
            {
              title: 'Ver equipos',
              icon: '',
              to: {
                name: 'equipments'
              }
            }
          ]
        },
        {
          title: 'Administradores',
          hidden: this.isInstaller() || this.isCommerce() || this.isAdmin() || this.isManager() || this.isResponsible(),
          icon: '',
          childs: [
            {
              title: 'Nuevo administrador',
              icon: '',
              to: {
                name: 'new-account',
                params: {
                  type: 'admin'
                }
              }
            },
            {
              title: 'Ver administradores',
              icon: '',
              to: {
                name: 'admins'
              }
            }
          ]
        },
        {
          title: 'Gerentes',
          hidden: this.isInstaller() || this.isCommerce() || this.isManager() || this.isResponsible(),
          icon: '',
          childs: [
            {
              title: 'Nuevo gerente',
              icon: '',
              to: {
                name: 'new-account',
                params: {
                  type: 'manager'
                }
              }
            },
            {
              title: 'Ver gerentes',
              icon: '',
              to: {
                name: 'managers'
              }
            }
          ]
        },
        {
          title: 'Encargados',
          hidden: this.isInstaller() || this.isCommerce() || this.isManager() || this.isResponsible(),
          icon: '',
          childs: [
            {
              title: 'Nuevo encargado',
              icon: '',
              to: {
                name: 'new-account',
                params: {
                  type: 'responsible'
                }
              }
            },
            {
              title: 'Ver encargados',
              icon: '',
              to: {
                name: 'responsibles'
              }
            }
          ]
        },
        {
          title: 'Comercios',
          hidden: this.isInstaller() || this.isCommerce(),
          icon: '',
          childs: [
            {
              title: 'Nuevo comercio',
              hidden: this.isManager() || this.isResponsible(),
              icon: '',
              to: {
                name: 'new-account',
                params: {
                  type: 'commerce'
                }
              }
            },
            {
              title: 'Ver comercios',
              icon: '',
              to: {
                name: 'commerces'
              }
            }
          ]
        },
        {
          title: 'Instaladores',
          hidden: this.isInstaller() || this.isCommerce() || this.isManager() || this.isResponsible(),
          icon: '',
          childs: [
            {
              title: 'Nuevo instalador',
              icon: '',
              to: {
                name: 'new-account',
                params: {
                  type: 'installer'
                }
              }
            },
            {
              title: 'Ver instaladores',
              icon: '',
              to: {
                name: 'installers'
              }
            }
          ]
        },
        {
          title: 'Instalaciones',
          hidden: this.isInstaller() || this.isCommerce() || this.isManager() || this.isResponsible(),
          icon: '',
          childs: [
            {
              title: 'Tipos de instalación',
              icon: '',
              to: {
                name: 'types',
                params: {
                  type: 'types'
                }
              }
            },
            {
              title: 'Inclusiones',
              icon: '',
              to: {
                name: 'inclusions',
                params: {
                  type: 'inclusions'
                }
              }
            },
            {
              title: 'Exclusiones',
              icon: '',
              to: {
                name: 'exclusions',
                params: {
                  type: 'exclusions'
                }
              }
            },
            {
              title: 'Observaciones',
              icon: '',
              to: {
                name: 'observations',
                params: {
                  type: 'observations'
                }
              }
            },
            {
              title: 'Materiales',
              icon: '',
              to: {
                name: 'materials',
                params: {
                  type: 'materials'
                }
              }
            }
          ]
        }
      ],
      miniVariant: false,
      right: true,
      rightDrawer: false,
      title: 'IBEC'
    }
  },

  methods:
  {
    /**
     * Check if it is a login page.
     *
     * @return {Boolean}
     */
    isSessionMannagerPage: function isSessionMannagerPage () {
      return this.$route.name === 'login' ||
             this.$route.name === 'register' ||
             this.$route.name === 'change-password' ||
             this.$route.name === 'recover-password'
    },

    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    isSuperadmin () {
      return this.$store.getters['api/getUserRol'] === 'superadmin'
    },

    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    isResponsible () {
      return this.$store.getters['api/getUserRol'] === 'responsible'
    },

    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    isManager () {
      return this.$store.getters['api/getUserRol'] === 'manager'
    },

    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    isAdmin () {
      return this.$store.getters['api/getUserRol'] === 'administrator'
    },

    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    logout () {
      this.$store.dispatch('api/logout')
      this.$router.push('/exit')
    },

    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    isCommerce () {
      return this.$store.getters['api/getUserRol'] === 'commerce'
    },

    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    isInstaller () {
      return this.$store.getters['api/getUserRol'] === 'installer'
    },

    /**
     * Check if it is a login page.
     *
     * @return {Boolean}
     */
    isLegalPage: function isLegalPage () {
      return this.$route.name === 'privacy-policy'
    },
  }
}
</script>

<style lang="sass">
/* OCULTA CHECKBOX Y ACCIONES EN TABLAS DE DATOS */
.hidden-table-item
  display: none

.page-title
  margin-top: -20px
  color: #868db1 !important
  margin-bottom: 60px

.list-title
  margin-left: 12px

footer > span
  margin: auto

.footer-app
  background: #373c40 !important

.footer-app-inside > div > div > a
  color: #42444a !important
  text-decoration: none

.footer-app > div > div > a
  color: #aeb0b1 !important

.footer-separator
  margin-left: 10px
  margin-right: 10px

.router-separator
  margin-left: 5px
  margin-right: 5px
  opacity: 0.3

.white-logo
  height: 38px

.container-size
  max-width: 1000px
</style>


// WEBPACK FOOTER //
// src/App.vue